// Shared appointment-slot logic — used by BookAppointmentScreen.js (generic slot booking)
// and the in-chat Swipe scheduler card (screens/swipe/chatSwipeFlow.js) so both offer the
// same "real-looking open slots only" pattern instead of two separate implementations.

export const CHANNELS = [
  { id: 'phone', label: 'Phone', icon: '📞' },
  { id: 'video', label: 'Video', icon: '💻' },
  { id: 'branch', label: 'Branch', icon: '🏦' },
];

// Deterministic upcoming weekday slots relative to now. Each slot carries both
// the display label and real start/end Date objects (1-hour appointment) so
// callers can build calendar events (.ics / "Add to Google Calendar") from it —
// not just show text.
const SLOT_TIMES = [
  { label: '10:00 AM', hour: 10, minute: 0 },
  { label: '2:30 PM', hour: 14, minute: 30 },
  { label: '4:15 PM', hour: 16, minute: 15 },
];
const APPOINTMENT_MINUTES = 60;

export function nextSlots(count = 3) {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const slots = [];
  const cursor = new Date();
  cursor.setDate(cursor.getDate() + 1);
  let i = 0;
  while (slots.length < count) {
    const dow = cursor.getDay();
    if (dow !== 0 && dow !== 6) { // weekdays only
      const time = SLOT_TIMES[i % SLOT_TIMES.length];
      const start = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate(), time.hour, time.minute);
      const end = new Date(start.getTime() + APPOINTMENT_MINUTES * 60000);
      slots.push({
        id: `${cursor.toISOString().slice(0, 10)}-${i}`,
        label: `${days[dow]} ${cursor.getMonth() + 1}/${cursor.getDate()}, ${time.label}`,
        start,
        end,
      });
      i += 1;
    }
    cursor.setDate(cursor.getDate() + 1);
  }
  return slots;
}
